import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';

type Tone = 'dark' | 'white' | 'bronze' | 'ghost';
const tone = (t: Tone) => (t === 'dark' ? '' : t);

/** The site's pill CTA with the little arrow that nudges up-right on hover. */
export function PillLink({ to, children, variant = 'dark', small, className = '', external }: { to: string; children: ReactNode; variant?: Tone; small?: boolean; className?: string; external?: boolean }) {
  const cls = `pill group ${tone(variant)} ${small ? 'sm' : ''} ${className}`;
  const inner = <><span>{children}</span><ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" /></>;
  return external
    ? <a href={to} target="_blank" rel="noreferrer" className={cls}>{inner}</a>
    : <Link to={to} className={cls}>{inner}</Link>;
}

export function PillButton({ children, variant = 'dark', small, className = '', ...rest }: React.ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Tone; small?: boolean }) {
  return (
    <button className={`pill group ${tone(variant)} ${small ? 'sm' : ''} ${className}`} {...rest}>
      <span>{children}</span>
      <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
    </button>
  );
}
